import { App } from '@prisma/client'
import { Button, Flex } from 'antd'
import React, { useState } from 'react'
import { AgentFacade } from '~/agents/facade/client'
import { AppSessionType } from '~/features/appSession/common'
import { FeatureFormConfigurationClientShared } from '~/features/formConfiguration/clientShared'
import { Icon } from '~/features/shared/icons'
import { Helper } from '../../helper'
import { HowDoesItWorkButton } from '../HowDoesItWorkButton'

type Props = {
  app: App
  appSession: AppSessionType
  onSubmit: () => void
}

export const AppSessionOnboardingButton: React.FC<Props> = ({
  app,
  appSession,
  onSubmit,
}) => {
  const [isSettingsVisible, setSettingsVisible] = useState(false)

  const name = Helper.getName(appSession)

  const demoUrl = app.demoUrl

  const { openOnboardingModal } = FeatureFormConfigurationClientShared.use()

  const handleClick = () => {
    // openOnboardingModal(appSession.id, onSubmit)
    setSettingsVisible(true)
  }

  return (
    <>
      <Flex className="pl-14" gap={8}>
        <Button
          onClick={handleClick}
          size="large"
          type="primary"
          icon={<Icon name="arrow-long-right" />}
        >
          Onboard {name}
        </Button>
        {demoUrl && <HowDoesItWorkButton demoUrl={demoUrl} />}
      </Flex>

      {isSettingsVisible && (
        <AgentFacade.Settings
          appKey={app.key}
          appSession={appSession}
          onSuccess={onSubmit}
          onClose={() => setSettingsVisible(false)}
        />
      )}
    </>
  )
}
